// extracted by mini-css-extract-plugin
module.exports = {"calTitleCustom":"LegalStaffFee_calTitleCustom__32K4c"};